import React from 'react';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import { IMenu } from './types';
import Icon from 'v2/components/Icon';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';

const MenuOptions: React.FC<IMenu> = ({
  title,
  iconName,
  iconLeft,
  iconRight,
  colorBackground = '#ececec',
  colorIcon = '#b1b1b1',
  open,
  maxWidthTitle,
  handleOpenChange,
  children,
}) => {
  const renderIcon = () => {
    if (iconName) {
      return <Icon iconName={iconName} size={22} htmlColor={colorIcon} />;
    }
  };

  const renderTitle = () => {
    return (
      <MenuButton
        sx={{
          borderRadius: '12px',
          background: colorBackground,
          padding: '14px 22px',
        }}
      >
        <Box gap={5} alignItems="center">
          {iconLeft && renderIcon()}

          <Text
            fontSize={17}
            fontWeight={700}
            margin={0}
            padding={0}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            maxWidth={maxWidthTitle || 250}
          >
            {title}
          </Text>

          {iconRight && renderIcon()}
        </Box>
      </MenuButton>
    );
  };

  return (
    <Dropdown open={open} onOpenChange={handleOpenChange}>
      {renderTitle()}

      <Menu
        sx={{
          borderRadius: '12px',
          margin: 0,
          padding: 0,
          maxHeight: '300px',
        }}
      >
        {children()}
      </Menu>
    </Dropdown>
  );
};
export default MenuOptions;
